import InvalidSession from 'components/InvalidSession';
import Loader from 'components/Loader';
import useSessionProvider from 'providers/SessionProvider';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import useFetch from 'use-http';
function generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

const Generate = () => {
    const { post, loading } = useFetch(process.env.REACT_APP_API_URL);
    const location = useLocation();
    const history = useNavigate();
    const { setStatus, status } = useSessionProvider();
    const [error, setError] = useState(false);
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const campaignId = query.get('campaignId');
        if (campaignId) {
            post(`/integration/intercept/${campaignId}`, {
                RequestId: generateUUID(),
                meta: {
                    RequestId: generateUUID()
                },
                customers: [
                    {
                        firstName: `Anonymous`,
                        lastName: `${Math.round(+new Date() / 1000)}`,
                        email: '',
                        phone: '',
                        channelCode: 5,
                        meta: {}
                    }
                ]
            })
                .then((x) => {
                    if (x && x.sessionId) {
                        history({ pathname: '/survey', search: `?session_id=${x.sessionId}` });
                    } else {
                        setError(true);
                        setStatus('InValid');
                    }
                })
                .catch((err) => {
                    setError(true);
                    setStatus('InValid');
                    console.log({ err });
                });
        } else {
            setStatus('InValid');
            setError(true);
        }
    }, [post, history, location.pathname, location.search, setStatus]);
    return (
        <div>
            {loading && !error && <Loader />}
            {error && <InvalidSession />}
        </div>
    );
};

export default Generate;
